// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__QHMZr","spin":"Spinner_spin__cY7Kh"};